import "./AboutUs.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import OurIndustrialLegacy from "./sections/OurIndustrialLegacy";
import CoreValuesMission from "./sections/CoreValuesMission";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <MainIndustrialHeader />
      <OurIndustrialLegacy />
      <CoreValuesMission />
      <IndustrialFooter />
    </div>;
}